const updates = [
  {
    date: '08-01',
    title: '《山海传说》票房破20亿，成为年度现象级国产动画',
    tag: '热映',
  },
  {
    date: '07-31',
    title: '暑期档观影指南更新：十大必看新片推荐清单出炉',
    tag: '推荐',
  },
  {
    date: '07-30',
    title: '片库新增50+高清影片，涵盖动作、悬疑、喜剧等多类型',
    tag: '上新',
  },
  {
    date: '07-29',
    title: 'CDN节点全面升级完成，晚高峰观影流畅度再提升30%',
    tag: '公告',
  },
  {
    date: '07-28',
    title: '电影排行榜算法优化：新增用户停留时长权重指标',
    tag: '更新',
  },
  {
    date: '07-27',
    title: '经典港片修复计划启动，《英雄本色》4K版即将上线',
    tag: '预告',
  },
  {
    date: '07-26',
    title: '悬疑片专题周开启：精选20部高分烧脑佳作限时推荐',
    tag: '活动',
  },
];

export default function Updates() {
  return (
    <section id="updates" className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950">
            最新快讯
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-500">
            影视动态与站内更新一手掌握
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-6 md:pl-8 border-l-2 border-accent-200">
            {updates.map((item, idx) => (
              <div
                key={idx}
                className={`relative pb-6 md:pb-7 ${idx === updates.length - 1 ? 'pb-0' : ''}`}
              >
                <div className="absolute -left-[17px] md:-left-[21px] top-0 w-3 h-3 md:w-3.5 md:h-3.5 rounded-full bg-accent-500 ring-4 ring-background-100"></div>
                <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3">
                  <span className="text-xs md:text-sm font-bold font-label text-accent-600 whitespace-nowrap">
                    {item.date}
                  </span>
                  <span className={`inline-flex px-2 py-0.5 rounded-full text-xs font-medium font-label whitespace-nowrap ${
                    item.tag === '热映'
                      ? 'bg-primary-100 text-primary-700'
                      : item.tag === '上新'
                      ? 'bg-accent-100 text-accent-700'
                      : item.tag === '公告'
                      ? 'bg-secondary-200 text-secondary-700'
                      : 'bg-background-200 text-foreground-600'
                  }`}>
                    {item.tag}
                  </span>
                  <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                    {item.title}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}